import { CompanyPage } from "../company/companyPage";
import { CompanyListItems } from "../company/companyListItems";
import { getApiCall, postApiCall } from "./tokenService";
import { UnitNodePermissions } from "../unit/unitNodePermissions";
import { CompanyEdit } from "../company/companyEdit";
import { CompanyEditSaveAdminSuccess } from "../company/companyEditSaveAdminSuccess";
import { CompanyEditSaveSuccess } from "../company/companyEditSaveSuccess";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";

// #region CompanyPage
export const getCompanyPage = (): Promise<CompanyPage> => {
    return getApiCall("api/company", CompanyPage);
};

export const getCompanyListItems = (pageSize: number, page: number, filter: string, companyGroupIds: string[], activityState: number, sortColumn: string, sortOrderIsAsc: boolean, ignoreCompanyGroupId: string, ignoreCompanyIds: string[]): Promise<CompanyListItems> => {
    return postApiCall("api/company/list", CompanyListItems, JSON.stringify({
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        companyGroupIds,
        activityState,
        ignoreCompanyGroupId,
        ignoreCompanyIds
    }));
};

export const getCompanyEdit = (companyId: string): Promise<CompanyEdit> => {
    return getApiCall("api/company/edit?id=" + companyId, CompanyEdit);
};

export const saveCompanyEdit = (obj: any): Promise<CompanyEditSaveSuccess> => {
    return postApiCall("api/company/editsave", CompanyEditSaveSuccess, JSON.stringify(obj));
};

export const saveCompanyEditAdmin = (obj: any): Promise<CompanyEditSaveAdminSuccess> => {
    return postApiCall("api/company/editsaveadmin", CompanyEditSaveAdminSuccess, JSON.stringify(obj));
};

export const removeCompany = (companyId: string): Promise<ApiSuccess> => {
    return postApiCall("api/company/remove?id=" + companyId, ApiSuccess);
};

export const companyEditRemoveCompanyGroups = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/company/editremovecompanygroups", ApiSuccess, JSON.stringify(obj));
};

export const companyEditAddCompanyGroups = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/company/editaddcompanygroups", ApiSuccess, JSON.stringify(obj));
};

export const companyEditRemovePartnerCompanies = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/company/editremovepartnercompanies", ApiSuccess, JSON.stringify(obj));
};

export const companyEditAddPartnerCompanies = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/company/editaddpartnercompanies", ApiSuccess, JSON.stringify(obj));
};
// #endregion CompanyPage

// #region Module properties
export const getUnitNodePermissions = (companyId: string): Promise<UnitNodePermissions> => {
    return getApiCall("api/company/module/permissions?id=" + companyId, UnitNodePermissions);
};

export const saveUnitNodePermissions = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/company/module/savepermissions", ApiSuccess, JSON.stringify(obj));
};
// #endregion Module properties
